<template>
    <breadcrumbs :crumbs="crumbs" />
    <article
        class="grid grid-cols-1 gap-8 pb-16 pt-8 px-4 at720:grid-cols-[25%_1fr] at1024:px-8 at1024:pb-32 at1024:pt-16"
    >
        <ul class="space-y-2" v-if="article.categories">
            <li v-for="category in article.categories">
                <a
                    :href="route('web.education.category.show', category.slug)"
                    class="inline-block px-6 py-2.5 bg-gray-125 text-gray-800 text-[13px] leading-tight uppercase font-medium tracking-widest hover:bg-gray-200"
                    v-text="category.name"
                />
            </li>
        </ul>
        <div class="max-w-[830px]">
            <p>
                <Link
                    :href="route('web.careers.index')"
                    class="flex font-bold items-center tracking-wider -translate-x-2 text-red uppercase hover:underline"
                >
                    <BaseSvg name="CaretPrevious" aria-hidden="true" />
                    {{ $t("Back") }}
                </Link>
            </p>
            <div class="copy-block mt-7">
                <time
                    pubdate="pubdate"
                    class="block mb-4 text-sm"
                    v-if="article.publish_date"
                >
                    {{ article.publish_date }}
                </time>
                <h1>{{ article.title }}</h1>
                <p class="-mt-5 text-gray-400">
                    {{ article.metadata?.type }} /
                    {{ article.metadata?.location }}
                </p>
                <p class="headline" v-if="article.headline">
                    {{ article.headline }}
                </p>
            </div>
            <div
                v-if="marketingAssetUrl(article.image)"
                class="at1024:-ml-24 at1200:-ml-42"
            >
                <img
                    :src="marketingAssetUrl(article.image)"
                    :alt="article.image.data.alt_text"
                    class="border"
                />
            </div>
            <div class="copy-block">
                <template v-for="block in article.content">
                    <h2>{{ block.heading }}</h2>
                    <div v-html="block.content"></div>
                </template>
            </div>
            <p class="mt-8">
                <Link
                    :href="
                        route('web.careers.apply', { article: article.slug })
                    "
                    class="btn-white-on-red"
                    >Apply now</Link
                >
            </p>
            <ShareButtons
                class="mt-8 print:hidden"
                :url="article.url"
                :title="article.title"
                :summary="article.headline"
            />
        </div>
    </article>
    <Meta :meta="article.meta" :title="article.title" :description="'A ' + article.title + ' position is available at SECLOCK. Come and work for the industry leader in door hardware.'" />
</template>
<script setup>
import { inject } from "vue";
import { Meta, ShareButtons, Breadcrumbs, BaseSvg } from "@/Components";
import { useJsonLd, useAssetTransforms } from "@/Composables";

const { marketingAssetUrl } = useAssetTransforms();
const route = inject("route");
const props = defineProps(["article", "crumbs"]);
const { jsonLdMainEntityBlogShow } = useJsonLd();
</script>
